// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"3e5bdc9d","453":"2cf89218","837":"de158a25"}[chunkId] + ".chunk.js";
};